module.exports = __webpack_public_path__ + "img/9.93d9d76c.png";